import React, { useState } from "react";
import "./Shared.css";
import NavBar from "../Assets/bar.svg";
import { Link } from "react-router-dom";

export default function Header() {
  const [showMenu, setShowMenu] = useState(false);

  return (
    <header className="w-[90%] md:w-[80%] mx-auto flex justify-between items-center pt-6 md:pt-12">
      <Link to="/" className="text-[34px] font-semibold logo">
        Amir
        <span className="w-[7px] h-[7px] bg-[#D46868] rounded-full inline-block relative bottom-[-2px] ml-[5px]"></span>
      </Link>

      {/* <div className="bg-[#0A0A0A] px-10 py-2 rounded">
        <ul className="flex gap-4 text-[13px] text-[#9D9DA5]">
          <li className="px-4 py-1 border border-green-700 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white">
            UI & UX
          </li>
          <li className="px-4 py-1 border border-green-700 rounded-full cursor-pointer hover:bg-slate-500/10 hover:text-white">
            Frontend
          </li>
          <li className="px-4 py-1 border border-green-700 rounded-full cursor-pointer hover:bg-slate-700/10 hover:text-white">
            Full Stack
          </li>
        </ul>
      </div> */}
      {/* hover:bg-[0f172a] */}
      <div
        onClick={() => setShowMenu(!showMenu)}
        className="relative cursor-pointer border border-[#0D1B2A] hover:border-violet-400/10 rounded-md px-2 py-1.5 rounded-lg transition"
      >
        {/* <img className="w-[25px] h-[25px] cursor-pointer" src={NavBar} alt="" /> */}
        <svg
          className="cursor-pointer -rotate-180"
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          viewBox="0 0 24 24"
        >
          <path
            fill="none"
            stroke="currentColor"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M4 9h16M4 15h10"
          />
        </svg>

        {/* menu */}
        <div
          className={`${
            showMenu
              ? "absolute right-[0%] top-[150%] z-[100] w-[290px] md:w-[350px]  border-slate-700 px-3 pt-3 pb-4 border border-slate-700 text-[#DEDEDE] bg-gradient-to-r from-slate-500/20 to-slate-500/30 via-slate-500/30 rounded-xl text-white backdrop-blur-xl shadow shadow-[#1E3A8A]/80 cursor-normal"
              : "hidden"
          }`}
        >
          <h6 className="mt-2 mb-3 text-[12px] font-light">Main Menu</h6>
          <ul className="flex flex-col gap-4 mt-2 justify-center font-semibold text-[16px] md:text-[18px]">
            <li>
              <Link
                onClick={() => setShowMenu(!showMenu)}
                className="px-3 bg-[#0f172a]/20 hover:bg-[#0f172a]/50 border border-[#0f172a]/20 hover:border-slate-700 flex gap-3 items-center py-1.5 rounded  w-full inline-block"
                to="/"
              >
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 24 24"
                >
                  <g fill="none" stroke="currentColor" stroke-width="2">
                    <path d="M2.364 12.958c-.38-2.637-.57-3.956-.029-5.083s1.691-1.813 3.992-3.183l1.385-.825C9.8 2.622 10.846 2 12 2s2.199.622 4.288 1.867l1.385.825c2.3 1.37 3.451 2.056 3.992 3.183s.35 2.446-.03 5.083l-.278 1.937c-.487 3.388-.731 5.081-1.906 6.093S16.553 22 13.106 22h-2.212c-3.447 0-5.17 0-6.345-1.012s-1.419-2.705-1.906-6.093z" />
                    <path stroke-linecap="round" d="M12 15v3" />
                  </g>
                </svg> */}
                <span>Home</span>
              </Link>
            </li>

            <li>
              <Link
                onClick={() => setShowMenu(!showMenu)}
                className="px-3 bg-[#0f172a]/20 hover:bg-[#0f172a]/50 border border-[#0f172a]/20 hover:border-slate-700 flex gap-3 items-center py-1.5 rounded  w-full inline-block"
                to="/project/uiux"
              >
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill="currentColor"
                    d="M12.5 4a.5.5 0 0 0 0-1h-9a.5.5 0 0 0 0 1z"
                    stroke-width="0.5"
                    stroke="currentColor"
                  />
                  <path
                    fill="currentColor"
                    fill-rule="evenodd"
                    d="M12.3 15c.975-.015 1.57-.077 2.05-.322a3 3 0 0 0 1.31-1.31c.327-.642.327-1.48.327-3.16v-4.4l-.005-1.11c-.015-.975-.077-1.57-.322-2.05l-.115-.206a2.94 2.94 0 0 0-1.2-1.1l-.123-.058c-.46-.198-1.03-.25-1.93-.265l-1.11-.004h-6.4c-1.68 0-2.52 0-3.16.327a3.07 3.07 0 0 0-1.2 1.1l-.115.206c-.245.48-.307 1.07-.322 2.05l-.005 1.11v4.4c0 1.58 0 2.41.27 3.04l.058.123c.252.494.635.907 1.1 1.2l.206.115c.642.327 1.48.327 3.16.327h6.4l1.11-.005zM1 5c.003-.445.01-.795.033-1.09c.036-.438.101-.663.181-.819c.192-.376.498-.682.874-.874c.156-.08.381-.145.82-.181c.45-.037 1.03-.037 1.89-.037h6.4c.855 0 1.44 0 1.89.037c.437.036.662.101.818.181c.376.192.682.498.874.874c.08.156.145.381.181.819c.024.294.03.643.033 1.09h-14zm3.8 9c-.856 0-1.44 0-1.89-.037c-.438-.036-.663-.101-.819-.181a2 2 0 0 1-.874-.874c-.08-.156-.145-.381-.181-.82c-.037-.45-.037-1.03-.037-1.89v-4.2h14v4.2c0 .857 0 1.44-.037 1.89c-.036.439-.101.664-.181.82a2 2 0 0 1-.874.874c-.156.08-.381.145-.82.18c-.45.038-1.03.038-1.89.038h-6.4z"
                    clip-rule="evenodd"
                    stroke-width="0.5"
                    stroke="currentColor"
                  />
                </svg> */}
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 16 16"
                >
                  <path
                    fill="currentColor"
                    d="M13.747 2.226H2.378a.904.904 0 0 0-.904.904v9.302a.904.904 0 0 0 .904.904h11.368a.904.904 0 0 0 .904-.904V3.13a.904.904 0 0 0-.904-.904m-11.368.775h11.368a.13.13 0 0 1 .129.13v2.712H2.249V3.13A.13.13 0 0 1 2.378 3m-.129 9.431V6.616h3.876v5.943H2.379a.13.13 0 0 1-.13-.129m11.497.129H6.899V6.617h6.976v5.814a.13.13 0 0 1-.129.129"
                    stroke-width="0.5"
                    stroke="currentColor"
                  />
                </svg> */}
                <span>UI & UX</span>
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setShowMenu(!showMenu)}
                className="px-3 bg-[#0f172a]/20 hover:bg-[#0f172a]/40 border border-[#0f172a]/20 hover:border-slate-700 flex gap-3 items-center py-1.5 rounded  w-full inline-block"
                to="/project/development"
              >
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="23"
                  height="23"
                  viewBox="0 0 24 24"
                >
                  <path
                    fill="none"
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm6 14h8"
                  />
                </svg> */}
                <span>Development</span>
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setShowMenu(!showMenu)}
                className="px-3 bg-[#0f172a]/20 hover:bg-[#0f172a]/50 border border-[#0f172a]/20 hover:border-slate-700 flex gap-3 items-center py-1.5 rounded  w-full inline-block"
                to="/project/all"
              >
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 2048 2048"
                >
                  <path
                    fill="currentColor"
                    d="M128 128h1664v1664H128zm1536 768V256h-640v640zM896 256H256v640h640zm-640 768v640h640v-640zm768 640h640v-640h-640z"
                  />
                </svg> */}
                <span>All Projects</span>
              </Link>
            </li>
            <li>
              <Link
                onClick={() => setShowMenu(!showMenu)}
                className="px-3 bg-[#0f172a]/20 hover:bg-[#0f172a]/50 border border-[#0f172a]/20 hover:border-slate-700 flex gap-3 items-center py-1.5 rounded  w-full inline-block"
                to="/"
              >
                {/* <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  viewBox="0 0 2048 2048"
                >
                  <path
                    fill="currentColor"
                    d="M128 128h1664v1664H128zm1536 768V256h-640v640zM896 256H256v640h640zm-640 768v640h640v-640zm768 640h640v-640h-640z"
                  />
                </svg> */}
                <span>Blogs</span>
              </Link>
            </li>
            <li>
              <a
                onClick={() => setShowMenu(!showMenu)}
                className="px-3 bg-[#0f172a]/20 hover:bg-[#0f172a]/50 border border-[#0f172a]/20 hover:border-slate-700 py-1.5 rounded  w-full inline-block"
                href="https://github.com/amiribnjaman"
                target="_blank"
              >
                Github
              </a>
            </li>
            <li>
              <a
                onClick={() => setShowMenu(!showMenu)}
                className="px-3 bg-[#0f172a]/20 hover:bg-[#0f172a]/50 border border-[#0f172a]/20 hover:border-slate-700 py-1.5 rounded  w-full inline-block"
                href="https://dribbble.com/amir_hosen"
                target="_blank"
              >
                Dribble
              </a>
            </li>
          </ul>
        </div>
      </div>
    </header>
  );
}
